/* eslint-disable no-unused-vars */
import React, { useEffect, useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import TransactionInformation from 'modules/common/components/TransactionInformation';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import { ModalContext } from 'App';
import { get, getJson } from 'session'; 
import VerifyReceipt from '../components/VerifyReceipt';
import * as action from '../action';
import * as c from '../constant';
import ApplicationInformation from './ApplicationInformation';

function ApplicationContent({
  transactionInfo,
  showTransaction,
  clearTransaction,
  startAssessment,
  isLoading,
  match,
  taxpayerProfile,
  onPrinted,
  onReceived
}) {

  const [formData, setFormData] = useState({});
  const setModal = useContext(ModalContext);
  const selectedTransaction = match.params.id;

  const token = get('token') || '';

  const authProfile = getJson('profile') || '';

  const updateData = () => {
    showTransaction(selectedTransaction);
  };

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
    return () => {
      clearTransaction();
    };
  }, []);

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
  }, [selectedTransaction]);

  const getInitials = (cString) => {
    if (cString) {
      const val = cString.replace(/\[^a-zA-Z- ]/g, '').match(/\b(\w)/g);
      const strFirstTwo = val.slice(0, 2);
      const final = strFirstTwo.join('');
      return final.toUpperCase();
    }
    return null;
  };

  const handleVerifyReceipt = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <VerifyReceipt
          transactionInfo={transactionInfo}
          id={selectedTransaction}
        />
      ),
      title: `Assess Payment Receipt`,
      modalSize: 'modal-md',
    });
  };

  const onStartAssessment = () => e => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure, do you want start assessment?`,
      () => {
        startAssessment(selectedTransaction, () => {
          showTransaction(selectedTransaction);
        });
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const onGenerate = (e) => {
    e.preventDefault();
    
    setFormData({
      ...formData,
      isLoading: true,
      generate: true,
      url: '',
    });

    const src = `${process.env.REACT_APP_WS}${c.GENERATE_POLICE_CLEARANCE}${selectedTransaction}/generate?bearer_token=${token}
    &email=${_.get(
      authProfile,
      'email'
    )}`;

    setTimeout(() => {
      window.location.href = src;
      setFormData({
        ...formData,
        isLoading: false,
        generate: false,
      });
    }, 100);

    setTimeout(() => {
       showTransaction(selectedTransaction);
    }, 2000);
  };


  const showVerifyReceipt = status => {
    return ['WAITING FOR PAYMENT', 'PAID', 'FOR PICK-UP', 'PENDING','FOR PRINTING'].includes(
      status
    );
  };

  return (
    <>
      <div className="card-section-content container-fluid">
        {isLoading && (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        )}
        <div className="right-section-content">
          <div className="row highlight d-flex align-items-center mx-3 py-3">
            <div className="col-12 px-0 mt-0 mb-1">
              <div className="card border-primary">
                <div className="container-fluid py-1">
                  <div className="p-0 d-flex flex-nowrap mb-3 w-100">
                    <div className="d-flex round-image justify-content-center">
                      <h3 className="d-flex align-items-center initials mb-0">
                        {_.get(taxpayerProfile, 'photo') !==
                        '-/format/jpeg/' ? (
                          <img
                            alt="Client Profile"
                            src={_.get(taxpayerProfile, 'photo')}
                          />
                        ) : (
                          getInitials(`${_.get(taxpayerProfile, 'name')}`)
                        )}
                      </h3>
                    </div>
                    <div className="d-flex ml-4 align-items-center">
                      <h1 className="transaction-company m-0">
                        {`${_.get(taxpayerProfile, 'first_name') || '-'} ${_.get(
                          taxpayerProfile,
                          'middle_name'
                        ) || ''} ${_.get(taxpayerProfile, 'last_name') || ''} ${_.get(
                          taxpayerProfile,
                          'extension_name'
                        ) || ''}`}
                      </h1>
                    </div>
                  </div>
                  <div className="d-flex ml-auto justify-content-end mb-3">
                    {showVerifyReceipt(
                        _.get(transactionInfo, 'attributes.transaction_status')
                    ) && (
                      <button
                        onClick={handleVerifyReceipt}
                        className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold mr-1"
                        type="button"
                      >
                        Assess Payment Receipt
                      </button>
                    )}
                    &nbsp;
                    {['FOR PRINTING'].indexOf(
                      _.get(transactionInfo, 'attributes.transaction_status')
                    ) > -1 &&
                      +_.get(
                        transactionInfo,
                        'attributes.is_start_assessment'
                      ) === 0 && (
                        <button
                          disabled={isLoading}
                          type="button"
                          onClick={onStartAssessment(transactionInfo)}
                          className="gen-btn btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold"
                        >
                          {isLoading ? (
                            <i className="fa fa-spin fa-spinner" />
                          ) : (
                            <>
                              Start Assessment &nbsp;&nbsp;
                              <i className="fas fa-check" />
                            </>
                          )}
                        </button>
                      )}
                    &nbsp;
                    {['FOR PRINTING'].indexOf(
                      _.get(transactionInfo, 'attributes.transaction_status')
                    ) > -1 &&
                      +_.get(
                      transactionInfo,
                      'attributes.is_start_assessment'
                    ) === 1 && (
                      <button
                        disabled={isLoading}
                        type="button"
                        onClick={onPrinted(transactionInfo)}
                        className="gen-btn btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold mr-2"
                      >
                        {isLoading ? (
                          <i className="fa fa-spin fa-spinner" />
                        ) : (
                          <>
                            Tag as Printed &nbsp;&nbsp;
                            <i className="fas fa-check" />
                          </>
                        )}
                      </button>
                    )}
                    {['PRINTED'].indexOf(
                      _.get(transactionInfo, 'attributes.transaction_status')
                    ) > -1
                    ? (
                      <button
                        disabled={isLoading}
                        type="button"
                        onClick={onReceived(transactionInfo)}
                        className="gen-btn btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold"
                      >
                        {isLoading ? (
                          <i className="fa fa-spin fa-spinner" />
                        ) : (
                          <>
                            Tag as Received &nbsp;&nbsp;
                            <i className="fas fa-check" />
                          </>
                        )}
                      </button>
                    )
                    : ''}
                    &nbsp;
                    {['FOR PRINTING'].indexOf(
                      _.get(transactionInfo, 'attributes.transaction_status')
                    ) > -1 &&
                      +_.get(
                        transactionInfo,
                        'attributes.is_start_assessment'
                      ) === 1 && (
                        <button
                          type="button"
                          onClick={onGenerate}
                          className="gen-btn btn btn-success font-weight-bold"
                        >
                          PRINT POLICE CLEARANCE{' '}
                          &nbsp;<i className="fas fa-print" />
                        </button> 
                      )}
                    &nbsp;
                    {['PRINTED','RECEIVED'].indexOf(
                      _.get(transactionInfo, 'attributes.transaction_status')
                    ) > -1 && (
                      <button
                        type="button"
                        onClick={onGenerate}
                        className="gen-btn btn btn-success font-weight-bold"
                      >
                        REGENERATE POLICE CLEARANCE{' '}
                        &nbsp;<i className="fas fa-print" />
                      </button> 
                    )}
                    &nbsp;
                  </div>     
                  <Tabs>
                    <TabList>
                      <Tab>Transaction</Tab>
                      <Tab>Information</Tab>
                    </TabList>
                    <TabPanel>
                      <TransactionInformation
                        module="pc"
                        transactionInfo={transactionInfo}
                      />
                    </TabPanel>
                    <TabPanel>
                      <ApplicationInformation />
                    </TabPanel>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

ApplicationContent.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  transactionInfo: PropTypes.instanceOf(Object).isRequired,
  startAssessment: PropTypes.instanceOf(Function).isRequired,
  clearTransaction: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  onPrinted: PropTypes.instanceOf(Object).isRequired,
  onReceived: PropTypes.instanceOf(Object).isRequired,
  taxpayerProfile: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  transactionInfo: _.get(api, `${c.SHOW_TRANSACTION}.item`) || {},
  taxpayerProfile: _.get(api, `${c.SHOW_TRANSACTION}.item.included.taxPayer.attributes`) || {},
  isLoading: api.loading.indexOf(c.SHOW_TRANSACTION) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(ApplicationContent);
